import axios from "../axiosInstance";
import {
  FetchStochasticInvoicesRequest,
  FetchStochasticInvoicesResponse,
} from "./types";

export const fetchStochasticInvoices = async (
  requestData: FetchStochasticInvoicesRequest,
): Promise<FetchStochasticInvoicesResponse> => {
  const response = await axios.get<FetchStochasticInvoicesResponse>(
    "/api/private/stochastic-invoices",
    {
      params: requestData,
    },
  );
  return response.data;
};
